var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92308 26L24.0769 26C25.139 26 26 25.139 26 24.0769L26 2.92308C26 1.86099 25.139 1 24.0769 1L2.92308 1C1.86099 1 1 1.86099 1 2.92308L1 24.0769C1 25.139 1.86099 26 2.92308 26Z",
    stroke: "#A140BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80762 5.80762H9.65377M5.80762 10.6153H14.4615M22.1538 10.6153L16.3845 20.2307L9.65377 16.3845L5.80762 22.1538",
    stroke: "#A140BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/Feature6.451245f9be0ab448f039530aa64d3a70.svg";
export { ForwardRef as ReactComponent };